
export const SENHA_MESTRA = "queroserbrmemsampa"; 